import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { t } from '../../../../lib/i18n';

class ContactConfirmation extends Component {
    render() {
        return (<div>
            <h1>{t('contactConfirmation.title')}</h1>

            <div>
                <p>{t('contactConfirmation.statusText')}</p>

                <p>{t('contactConfirmation.greetingsText')}</p>

                <p>
                    <button
                      onClick={() => this.props.onGoToOfferButtonClicked()}
                      className="action-button"
                    >
                        {t('contactConfirmation.backToOfferButtonLabel')}
                    </button>
                </p>
            </div>
        </div>);
    }
}

ContactConfirmation.propTypes = {
    onGoToOfferButtonClicked: PropTypes.func,
};


const StyledContactConfirmation = styled(ContactConfirmation)`
    p:not(:last-child) {
        margin-bottom: 1em;
    }
    button.close-dialog {
        display: none;
    }
`;

export default StyledContactConfirmation;



// WEBPACK FOOTER //
// ./src/pages/status-overview/contact-form/contact-confirmation/contact-confirmation.jsx